var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-grade-post-list" },
    [
      _c("p", { staticClass: "text large bold dark" }, [
        _vm._v("HSCYLC Certificate Request 证书订购")
      ]),
      _vm._m(0),
      _c("p", { staticClass: "big bold dark mt-30" }, [_vm._v("我的订单")]),
      _c(
        "ElTable",
        { staticClass: "mt-10 table-wrap", attrs: { data: _vm.orderData } },
        [
          _c("ElTableColumn", {
            attrs: { prop: "time", label: "日期", width: "180" }
          }),
          _c("ElTableColumn", { attrs: { prop: "feeStr", label: "金额" } }),
          _c("ElTableColumn", {
            attrs: { prop: "paidState", label: "支付状态" }
          }),
          _c("ElTableColumn", {
            attrs: { prop: "expressState", label: "寄送状态" }
          }),
          _c("ElTableColumn", {
            attrs: { width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.isPaid
                      ? _c(
                          "Button",
                          {
                            staticClass: "btn-detail",
                            attrs: { size: "small", skin: "grey" },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("查看详情")]
                        )
                      : _c(
                          "Button",
                          {
                            staticClass: "btn-detail",
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("支付订单")]
                        )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "a",
        {
          staticClass: "mt-10 reload link text red bold",
          on: { click: _vm.resetOrderData }
        },
        [_vm._v("刷新")]
      ),
      _c(
        "Button",
        {
          staticClass: "btn-submit mt-30",
          on: {
            click: function($event) {
              return _vm.handleClick()
            }
          }
        },
        [_vm._v("新建订单")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text mt-20" }, [
      _vm._v(
        " 峰会将为校友提供证书的补寄服务，证书中将体现校友的姓名、参加年份及所在会场，请根据表格要求填写。对于你的证书寄送有任何问题，可以通过 "
      ),
      _c(
        "a",
        { staticClass: "bold link", attrs: { href: "mailto:apply@hsylc.cn" } },
        [_vm._v("apply@hsylc.cn")]
      ),
      _vm._v(" 联系我们。 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }